import React, { useMemo } from 'react'
import { usePdp } from '~/contexts/PdpContext'
import { jnstyls } from '~/utils/helpers'

import * as styles from "~/styles/pdp/reviews.module.scss"

const ReviewStars = ({ istop=false, desk=false }) => {
  const { reviews } = usePdp()

  const overall = useMemo(() => {
    if (!reviews) return 0
    let score = 0
    reviews.forEach(x => score += x.rating)
    score = (score / reviews.length)
    if (score.length === 1) return score

    return Math.round(score * 10) / 10
  }, [reviews])

  const handleClick = () => {
    const revs = document.querySelector('[revs-wr]')
    if (!revs) return

    const revs_top = revs.getBoundingClientRect().top - 20
    window.scrollTo({
      top: revs_top,
      behavior: 'smooth'
    })
  }
  
  return (reviews?.length > 0) ? (
    <>
      {istop ? (
        <button
          type={'button'}
          className={jnstyls([styles.top_btn, desk ? styles.desk_top : styles.mobi_top])}
          onClick={(e)=>{handleClick()}}
        >
          <Stars reviews={reviews} overall={overall} />
          <div className={styles.over_cnt}>
            {reviews.length} Review{reviews.length > 1 ? 's' : ''}
          </div>
        </button>
      ) : (
        <>
          <span className={styles.over_total}>
            {reviews ? (
              <>
                {overall} STAR{overall > 1 ? 'S' : ''}
              </>
            ) : (
              <>&nbsp;&nbsp;&nbsp;&nbsp;</>
            )}
          </span>
          <Stars reviews={reviews} overall={overall} />
        </>
      )}
    </>
  ) : (reviews === false) ? (
    <div className={jnstyls([styles.loading, desk ? styles.desk_top : styles.mobi_top])}>
      <div className={jnstyls([styles.rating,styles.over_rating])}>
        {[...Array(5)].map((_, i) => (
          <div key={`overstar_load_${i}`} className={jnstyls([styles.empty])}>★</div>
        ))}
      </div>
      <div className={styles.over_cnt} />
    </div>
  ) : (
    <></>
  )
}



const Stars = ({ reviews, overall }) => {
  const overHalf = (i) => {
    if (!overall.toString().includes('.')) return ''
    if (parseInt((overall).toFixed(0)) === i + 1) return styles.half
    return ''
  }
  
  return (
    <div className={jnstyls([styles.rating, styles.over_rating])}>
      {[...Array(5)].map((_, i) => (
        <div 
          key={`overstar_${i}`} 
          className={jnstyls([styles.star, i < overall ? styles.filled : styles.empty, overHalf(i)])}
        >
          ★
        </div>
      ))}
    </div>
  )
}

export default ReviewStars

